import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    overviewFilterProductTypes: [
        'ACCOUNTS',
        'CARDS',
        'INSURANCES',
        'BUILDINGS',
        'PENSIONS',
        'LEASINGS',
        'SECURITIES',
    ],
    overviewFilterCaseStatuses: [
        'FOR_SIGNING',
        'SIGNED',
        'FOR_DISPLAY',
        'DISPLAYED',
        'REJECTED',
        'CANCELLED',
        'EXPIRED',
        'CLOSED',
        'RE_UPLOAD_REQUIRED',
        'FOR_UPLOAD',
        'PENDING_APPROVAL',
    ],
    overviewFilterText: true,
    overviewFilterProduct: true,
    overviewFilterProductType: true,
    overviewFilterCaseType: true,
    overviewFilterCaseTypes: ['CONTRACTS', 'INFORMATIONAL', 'STATEMENTS', 'SERVICES', 'OTHERS'],
    overviewFilterCaseStatus: true,
    displayCaseType: true,
    documentsPackageDownload: true,
};
